module.exports = __webpack_public_path__ + "media/images/front/icon_04_arrow_y-b9a2f7eb7732847a64af7ce6814e6254.png";